import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ErrorImage from '../components/ErrorImage/ErrorImage';
import ReactGA from 'react-ga';
import { GACategories, GAActions } from '../analytics';

class ErrorHandler extends Component {
  state = {
    hasError: false,
  };

  componentDidCatch(error, info) {
    this.setState({ hasError: true });

    ReactGA.event({
      category: GACategories.error,
      action: GAActions.javascriptError,
    });

    window.console.error('ERROR:', error + '\nInfo:', info);

    if (this.props.errorHandler) {
      this.props.errorHandler(error);
    }
  }

  render() {
    const { t } = this.props;

    if (this.state.hasError) {
      return (
        <ErrorImage
          errorType={t('javascript_error_message')}
          errorHeading={t('javascript_error_heading')}
          errorMessage={t('generic_error_type')}
        />
      );
    }

    return this.props.children;
  }
}

ErrorHandler.propTypes = {
  children: PropTypes.node,
  errorHandler: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default withTranslation('error')(ErrorHandler);
